module.exports = __webpack_public_path__ + "static/img/20200518-3.75b0e6e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/20200518-3.png
// module id = vY/1
// module chunks = 1